export type Disposable = {
    dispose(): void;
};

export function dispose(disposable: Disposable[]|Disposable) {
    if (Array.isArray(disposable)) {
        for (const d of disposable) {
            dispose(d);
        }
    } else {
        disposable.dispose();
    }
}
